import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
// FontAwesome normally injects this at runtime into document.head, but the embed app
// renders inside a shadow root, which that injection can't reach. Import it statically
// instead so it bundles into styles-embed-<client>.css, which is loaded inside the shadow root.
import '@fortawesome/fontawesome-svg-core/styles.css';
import {
  faStar,
  faBolt,
  faHeart,
  faFlame,
  faTag,
  faBell,
  faTrophy,
  faSparkles,
} from '@fortawesome/pro-solid-svg-icons';

const FONTAWESOME_TRENDING_ICONS: Record<string, IconDefinition> = {
  star: faStar,
  bolt: faBolt,
  heart: faHeart,
  flame: faFlame,
  tag: faTag,
  bell: faBell,
  trophy: faTrophy,
  sparkles: faSparkles,
};

interface TrendingIconProps {
  icon?: string;
}

export default function TrendingIcon(props: TrendingIconProps) {
  const faIcon = props.icon && props.icon !== 'fire' ? FONTAWESOME_TRENDING_ICONS[props.icon] : undefined;

  if (faIcon) {
    return <FontAwesomeIcon icon={faIcon} className="go-trending-icon text-crimson mr-1" />;
  }

  return <span className="text-crimson goapp-icon-fire-solid mr-1"></span>;
}
